import { Api } from './Api';


export function* tutorSignUp(data){
    const jsonData = yield Api.formPost("/frogtutoring/tutorsignup", data);
    return jsonData;
}

export function* tutorProfileUpdate(data){
    const jsonData = yield Api.formPost("/frogtutoring/tutorupdate", data);
    return jsonData;
}